import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from 'constants/types';
import { States } from 'constants/states';
import { errorClearAction } from 'redux/actions/static/errorActions';
import useTranslate from 'hooks/useTranslate';
import Error from 'components/Error/Error';
import { useHistory } from 'react-router-dom';

const ErrorPage = () => {
  const history = useHistory();

  const dispatch = useDispatch();

  const [getText] = useTranslate();

  const errorState = useSelector((state: IRootState) => state?.[States.ERROR]);
  const errorMessage = errorState?.message;
  const errorData = getText(errorMessage || ['words', 'errorText']);
  const errorFrom = errorState?.from;
  const errorLang = errorState?.lang;

  const langState = useSelector((state: IRootState) => state?.[States.LANG]);
  const langValue = langState?.lang;

  useEffect(() => {
    if ((errorLang !== langValue) && errorFrom) {
      history.replace(errorFrom);
    }
  }, [errorLang, langValue, errorFrom]);

  useEffect(() => () => {
    dispatch(errorClearAction());
  }, []);

  return (
    <Error
      title={['words', 'errorTitle']}
      data={errorData}
    />
  );
};

export default ErrorPage;
